define('adminAnaAssayDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminAnaAssayDetailsView',
  'emptyView',
  'anaAssayDetailTabController',
  'rolesMixin',
  'settings',
  'entities/anaassays'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  anaAssayDetailTabController
) {
  'use strict';

  var AnaAssaysDetailsController = {
    fetchAnaAssay: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showAnaAssay(data);
      } else {
        this.model = App.request('anaassay:model', { secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showAnaAssay(data);
          }
        });
      }
    },

    showAnaAssay: function(data) {
      var view = new View({model: this.model, data: data});
      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);
      this.displayTabs(data);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {          
          default:
            anaAssayDetailTabController.showTab(data);
            break;
        }
      } else {
        anaAssayDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    }    
  };

  module.exports = AnaAssaysDetailsController;
});
